type placeHolderCatalog = {
  languageData: Record<string, any>;
  messages: Record<string, any>;
};

declare global {
  interface Window {
    dataLayer?: Array<Record<string, any>>;
    __REACT_QUERY_STATE__?: Record<string, any>;
    __ROVER_I18N_CONFIG_SHARED__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_REACT_LIB__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_REACT_APP__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_RSDK__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_KIBBLE__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_TYPES__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_UTILS__?: placeHolderCatalog;
    __ROVER_I18N_CONFIG_PAGES__?: placeHolderCatalog;
    __ROVER__ENV__?: {
      ROVER_ENVIRONMENT: string;
      GOOGLE_MAPS_API_KEY: string;
      AMPLITUDE_API_KEY: string;
    };
    clipboardData?: {
      getData: (format: string) => string;
    };
    __ROVER_INITIAL_DATA__?: Record<string, any>;
    domNode?: HTMLElement;
  }
}

const windowExists = typeof window !== 'undefined';

if (windowExists) {
  window.dataLayer = window.dataLayer || [];
}

export const pushEventWithDebug = (event: Record<string, any>): void => {
  // eslint-disable-next-line no-console
  console.debug('dataLayer', event);
  window.dataLayer?.push(event);
};

export default windowExists ? window.dataLayer : undefined;
